import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Home from './pages/Home';
import Login from './pages/Login';
import MakeOrder from './pages/MakeOrder';
import VisionaryOrder from './pages/VisionaryOrder';
import Stock from './pages/Stock';
import Visionaries from './pages/Visionaries';
import EODReports from './pages/EODReports';
import Orders from './pages/Orders';
import Navbar from './components/Navbar';
import Account from './pages/Account';
import Staff from './pages/Staff';
import SplashScreen from './pages/SplashScreen';
import Warehouse from './pages/Warehouse';

const FLOATING_ELEMENTS = 8;

function generateFloatingElements() {
  return Array.from({ length: FLOATING_ELEMENTS }, (_, i) => ({
    id: i,
    style: {
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`,
      animationDelay: `${Math.random() * 5}s`
    }
  }));
}

// Simple layout without demo context for now
function Layout({ children }: { children: React.ReactNode }) {
  return children;
}

// Simple protected route without demo context for now
function ProtectedRoute({ 
  children, 
  allowedRoles 
}: { 
  children: React.ReactNode;
  allowedRoles: string[];
}) {
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/splash" element={<SplashScreen />} />
      <Route path="/login" element={<Login />} />
      <Route path="/home" element={<Home />} />
      <Route path="/make-order" element={<MakeOrder />} />
      <Route path="/visionaries" element={<Visionaries />} />
      <Route path="/stock" element={<Stock />} />
      <Route path="/eod-reports" element={<EODReports />} />
      <Route path="/staff" element={<Staff />} />
      <Route path="/warehouse" element={<Warehouse />} />
      <Route path="/shop" element={<VisionaryOrder />} />
      <Route path="/orders" element={<Orders />} />
      <Route path="/account" element={<Account />} />
      <Route path="/" element={<Home />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

function AppContent() {
  return (
    <>
      {generateFloatingElements().map(element => (
        <div
          key={element.id}
          className="floating-element"
          style={element.style}
        />
      ))}
      <Layout>
        <AppRoutes />
      </Layout>
    </>
  );
}

function App() {
  console.log('App component rendering with basic structure...');
  
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;